import api from "services/api";
import { API_URL_VERSION } from "constants/environment";

export const ENDPOINT_PROFILES = API_URL_VERSION + "perfis";
export const ENDPOINT_PROFILES_LIST = ENDPOINT_PROFILES + "/listar";

export const profilesService = {
  list: async () => {
    try {
      const response = await api.get(ENDPOINT_PROFILES);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || "settings.user.profiles.messages.errors.list";
    }
  },

  create: async (data) => {
    try {
      const response = await api.post(ENDPOINT_PROFILES, data);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || "settings.user.profiles.messages.errors.create";
    }
  },

  find: async (id) => {
    try {
      const response = await api.get(`${ENDPOINT_PROFILES}/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || "settings.user.profiles.messages.errors.find";
    }
  },

  update: async (id, data) => {
    try {
      const response = await api.put(`${ENDPOINT_PROFILES}/${id}`, data);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || "settings.user.profiles.messages.errors.update";
    }
  },

  delete: async (id) => {
    try {
      const response = await api.delete(`${ENDPOINT_PROFILES}/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || "settings.user.profiles.messages.errors.delete";
    }
  },
};
